import { DirectPaths } from "@/config/routes";

//
export const ICM_NAME_SHORT = "ICU"; // company short name.
export const ICM_NAME_FULL = "InCred Unlisted"; // company long name.
export const INCREDUNLISTED = "incredunlisted"; // company long name.
export const ICM_ADVISORY = "icmAdvisory"; // advisory partner name.

// SOCIAL
export const ICM_BLOGS_URL = "https://www.incredunlisted.com/blog/";
export const INSTAGRAM = "https://www.instagram.com/incredunlisted/";
export const FACEBOOK = "https://www.facebook.com/share/18wc9LuLVA/";
export const X_TWITTER = "https://x.com/InCredUnlisted";
export const LINKEDIN = "https://www.linkedin.com/company/incredunlisted/";
export const YOUTUBE = "https://www.youtube.com/@InCredUnlisted";

// OTHERS
export const SEBI = "https://www.sebi.gov.in/";
export const NSE = "https://www.nseindia.com/";
export const BSE = "https://www.bseindia.com/";
export const CDSL = "https://www.cdslindia.com/";
export const ICM_PHN_1 = "+91 85918 71028";
export const ICM_PHN_2 = "+91 89282 50817";
export const ICM_MAIL = "connect@incredunlisted.com";
export const ICM_MAIL_SUPPORT = "support@incredunlisted.com";
export const ICM_ZOOM = "https://scheduler.zoom.us/incred-unlisted/incred-unlisted";
export const ICM_NEWS_LINK = "https://www.incredunlisted.com/blog/market-news/";
export const archana_conceptpr = "archana@conceptpr.com";
export const huda_conceptpr = "huda@conceptpr.com";
export const priyansh_saxena_incredmoney = "priyansh.saxena@incredunlisted.com";
export const mohit_yadav_incredmoney = "mohit.yadav@incredunlisted.com";
export const pratham_hegde_incredmoney = "pratham.hegde@incredunlisted.com";
export const vipin_kumar_incredmoney = "vipin.kumar@incredunlisted.com";
export const vijay_kuppa_incredmoney = "vijay.kuppa@incredunlisted.com";


export const routeBasedLogoUrl = [
    {
        host: `${process.env.ICM_URL}${DirectPaths.UNLISTED_SHARES}`,
        logoUrl: `${process.env.ICM_UE_LOGO_URL}`,
    }
];

//icm-refer-benifit
export const ICM_REFER_AMAZON_BENEFIT = 200;
export const ICM_REFER_BENEFIT = 0.25;
export const ICM_REFERRER_AMAZON_BENEFIT = 750;
export const ICM_REFERRER_BENEFIT = 1;

// Data
export const TESTIMONIALS = [
    {
        said: "These guys have a good track record, so it was a no-brainer for me to invest about 4 lakhs in their first issue. I'll also recommend to my family & friends to invest",
        by: "Lakshminarayanan Iyer",
    },
    {
        said: "All information required for me to invest has been laid out in a transparent manner. Webinar has helped me take an informed decision.",
        by: "Nidhi Agarwal",
    },
];

export const INNEWS = [
    {
        said: "Oyo expands leadership team.",
        by: "The Economic Times",
    },
    {
        said: "Oyo expands leadership team.",
        by: "The Economic Times",
    },
    {
        said: "Oyo expands leadership team.",
        by: "The Economic Times",
    },
];

export const AVG_TRANSACTIONS_VALUE = 10000;
export const MAX_EARNING = 10750;
export const AMZ_VOUCHER = 750;
export const FIRST_TRANSACTION_AMT = 200;
export const UPI_MAX_AMT = 100000;

/** Product codes excluded from sitemap and server-side crawlable links (e.g. ZEP01 - Zepto Ltd) */
export const UNLISTED_EXCLUDE_FROM_CRAWLABLE_LINKS: string[] = ["ZEP01", "SP02", "ICFS", "INC01"];

export const UE_METADATA = {
    title: "Buy & Sell Unlisted Shares, Pre - IPO Shares online | " + ICM_NAME_FULL,
    keywords: "Invest in Unlisted Shares, Stocks & Pre IPO companies online | " + ICM_NAME_FULL,
    description:
        "Securely buy/sell unlisted shares through our verified platform. Invest in Unlisted Stocks or Sell Unlisted Shares Online at good price in India with " +
        ICM_NAME_FULL,
    ogUrl: process.env.ICM_URL,
    ogTitle: "Buy & Sell Unlisted Shares, Pre - IPO Shares online | " + ICM_NAME_FULL,
    ogDescription:
        "Securely buy/sell unlisted shares through our verified platform. Invest in Unlisted Stocks or Sell Unlisted Shares Online at good price in India with " +
        ICM_NAME_FULL,
    ogImgUrl: `${process.env.ICM_PUBLIC_ASSETS_URL}icm-white-logo.webp?timestamp=${Date.now()}`,
    alternates: { canonical: `${process.env.ICM_URL}/unlisted-shares` },
};

export const PROFILE_METADATA = {
    title: "Buy & Sell Unlisted Shares, Stocks & Pre IPO Shares Online | " + ICM_NAME_FULL,
    keywords: "Invest in Unlisted Shares, Stocks & Pre IPO companies online | " + ICM_NAME_FULL,
    description:
        "Invest in unlisted shares and Pre-IPO companies like OYO, NSE, Utkarsh and Swiggy with " +
        ICM_NAME_FULL +
        " for higher returns. Buy and sell online today!",
    ogUrl: process.env.ICM_URL,
    ogTitle: "Buy & Sell Unlisted Shares, Stocks & Pre IPO Shares Online | " + ICM_NAME_FULL,
    ogDescription:
        "Invest in unlisted shares and Pre-IPO companies like OYO, NSE, Utkarsh and Swiggy with " +
        ICM_NAME_FULL +
        " for higher returns. Buy and sell online today!",
    ogImgUrl: `${process.env.ICM_PUBLIC_ASSETS_URL}icm-white-logo.webp?timestamp=${Date.now()}`,
};

export const FD_METADATA = {
    title: "",
    description: "",
    keywords: "",
    ogUrl: "",
    ogTitle: "",
    ogDescription: "",
    ogImgUrl: "",
    alternates: { canonical: "" },
};

export const Portfolio_METADATA = {
    title: "InCredUnlisted Portfolio | " + ICM_NAME_FULL,
    keywords: "InCredUnlisted Portfolio | " + ICM_NAME_FULL,
    description: "Portfolio page of " + ICM_NAME_SHORT,
    ogUrl: `${process.env.ICM_URL}/portfolio`,
    ogTitle: "Portfolio page of " + ICM_NAME_SHORT,
    ogDescription: "Portfolio page of " + ICM_NAME_SHORT,
    ogImgUrl: `${process.env.ICM_PUBLIC_ASSETS_URL}icm-white-logo.webp?timestamp=${Date.now()}`,
    alternates: { canonical: `${process.env.ICM_URL}/portfolio` },
};

export const REFER_METADATA = {
    title: ICM_NAME_FULL + " Referral - Refer Your Friends & Earn Rewards",
    keywords: "Alternate Investment Platform - Best Passive Income Investment",
    description: "Earn exciting rewards by referring your friends and family to " + ICM_NAME_FULL,
    ogUrl: process.env.ICM_URL,
    ogTitle: ICM_NAME_FULL + " Referral - Refer Your Friends & Earn Rewards",
    ogDescription: "Earn exciting rewards by referring your friends and family to " + ICM_NAME_FULL,
    ogImgUrl: `${process.env.APP_IMAGES_PATH}icm-white-logo.webp?timestamp=${Date.now()}`,
};

export const LOGIN_MEATADATA = {
    title: "Buy & Sell Unlisted Shares, Stocks & Pre IPO Shares Online | " + ICM_NAME_FULL,
    keywords: "Invest in Unlisted Shares, Stocks & Pre IPO companies online | " + ICM_NAME_FULL,
    description:
        "Invest in unlisted shares and Pre-IPO companies like OYO, NSE, Utkarsh and Swiggy with " +
        ICM_NAME_FULL +
        " for higher returns. Buy and sell online today!",
    ogUrl: process.env.ICM_URL,
    ogTitle: "Buy & Sell Unlisted Shares, Stocks & Pre IPO Shares Online | " + ICM_NAME_FULL,
    ogDescription:
        "Invest in unlisted shares and Pre-IPO companies like OYO, NSE, Utkarsh and Swiggy with " +
        ICM_NAME_FULL +
        " for higher returns. Buy and sell online today!",
    ogImgUrl: `${process.env.ICM_PUBLIC_ASSETS_URL}icm-white-logo.webp?timestamp=${Date.now()}`,
};

export const NEUTRAL_METADATA = {
    title: " Invest in Pre-IPO Shares, Fixed Deposits & Bonds | " + ICM_NAME_FULL,
    keywords: "Alternate Investment Platform - Best Passive Income Investment",
    description:
        "Diversify your investment portfolio with unlisted shares, FDs, and bonds for higher returns. Get started with " +
        ICM_NAME_FULL,
    itempropName: "Alternate Investment Platform - Best Passive Income Investment",
    itempropDescription:
        "Diversify your investment portfolio with unlisted shares, FDs, and bonds for higher returns. Get started with " +
        ICM_NAME_FULL,
    ogUrl: process.env.ICM_URL,
    ogTitle: "Invest in Pre-IPO Shares, Fixed Deposits & Bonds | " + ICM_NAME_FULL,
    ogDescription:
        "Diversify your investment portfolio with unlisted shares, FDs, and bonds for higher returns. Get started with " +
        ICM_NAME_FULL,
    ogImgUrl: `${process.env.APP_IMAGES_PATH}icm-white-logo.webp?timestamp=${Date.now()}`,
};

export const DISCLAIMER_METADATA = {
    title: `Legal Disclaimer - ${ICM_NAME_FULL}`,
    keywords: "Alternate Investment Platform, Unlisted Shares, Pre-IPO Investments, Passive Income Investments",
    description: `Read the ${ICM_NAME_FULL} disclaimer to understand the terms, risks, and important information before investing in unlisted shares and making financial decisions.`,
    itempropDescription: "",
    ogDescription: `Read the ${ICM_NAME_FULL} disclaimer to understand the terms, risks, and important information before investing in unlisted shares and making financial decisions.`,
    ogTitle: `Legal Disclaimer - ${ICM_NAME_FULL}`,
    ogImgUrl: `${process.env.APP_IMAGES_PATH}icm-white-logo.webp?timestamp=${Date.now()}`,
};

export const POLICY_METADATA = {
    title: "Policy Center | " + ICM_NAME_FULL,
    keywords: "Alternate Investment Platform - Best Passive Income Investment",
    description:
        "Diversify your investment portfolio with unlisted shares, FDs, and bonds for higher returns. Get started with " +
        ICM_NAME_FULL,
    itempropDescription: "",
    ogDescription:
        "Diversify your investment portfolio with unlisted shares, FDs, and bonds for higher returns. Get started with " +
        ICM_NAME_FULL,
    ogTitle: "Legal Policy - " + ICM_NAME_FULL,
    ogImgUrl: `${process.env.APP_IMAGES_PATH}icm-white-logo.webp?timestamp=${Date.now()}`,
};

export const CONTACT_METADATA = {
    title: "Contact Us - " + ICM_NAME_FULL,
    keywords: "Alternate Investment Platform - Best Passive Income Investment",
    description:
        "Contact us for any inquiries, questions, or assistance you need. Our team is here to help you with prompt and reliable support. Reach out to us today!",
    ogTitle: "Contact Us - " + ICM_NAME_FULL,
    ogDescription:
        "Contact us for any inquiries, questions, or assistance you need. Our team is here to help you with prompt and reliable support. Reach out to us today!",
    ogUrl: process.env.ICM_URL,
    itempropDescription:
        "Contact us for any inquiries, questions, or assistance you need. Our team is here to help you with prompt and reliable support. Reach out to us today!",
    ogImgUrl: `${process.env.APP_IMAGES_PATH}icm-white-logo.webp?timestamp=${Date.now()}`,
};

export const PRIVACY_POLICY_METADATA = {
    title: "Privacy Policy - " + ICM_NAME_FULL,
    ogTitle: "Privacy Policy - " + ICM_NAME_FULL,
    keywords: "Alternate Investment Platform - Best Passive Income Investment",
    description:
        "Explore " +
        ICM_NAME_FULL +
        "'s Privacy Policy and start your journey in alternative assets with confidence. Discover how we prioritize your data security.",
    itempropDescription:
        "Explore " +
        ICM_NAME_FULL +
        "'s Privacy Policy and start your journey in alternative assets with confidence. Discover how we prioritize your data security.",
    ogDescription:
        "Learn how we collect, use, and protect your personal information in our privacy policy.",
    ogUrl: process.env.ICM_URL,
    ogImgUrl: `${process.env.APP_IMAGES_PATH}icm-white-logo.webp?timestamp=${Date.now()}`,
};

export const TERMS_OF_USE_METADATA = {
    title: "Terms and Conditions - " + ICM_NAME_FULL,
    ogTitle: "Terms and Conditions - " + ICM_NAME_FULL,
    keywords: "Alternate Investment Platform - Best Passive Income Investment",
    description:
        "Explore our T&C page for guidelines for your use of our services. Learn more to ensure a transparent and reliable experience with us.",
    itempropDescription:
        "Explore our T&C page for guidelines for your use of our services. Learn more to ensure a transparent and reliable experience with us.",
    ogDescription:
        "Explore our T&C page for guidelines for your use of our services. Learn more to ensure a transparent and reliable experience with us.",
    ogUrl: process.env.ICM_URL,
    ogImgUrl: `${process.env.APP_IMAGES_PATH}icm-white-logo.webp?timestamp=${Date.now()}`,
};

export const ABOUT_METADATA = {
    title: "About " + ICM_NAME_FULL + " | Democratising Alternate Investments",
    keywords: "Alternate Investment Platform - Best Passive Income Investment",
    description:
        "Discover how " +
        ICM_NAME_FULL +
        ", the premier alternate asset investment platform, empowers investors to diversify their portfolios.",
    ogTitle: "About " + ICM_NAME_FULL + " | Democratising Alternate Investments",
    ogDescription:
        "Discover how " +
        ICM_NAME_FULL +
        ", the premier alternate asset investment platform, empowers investors to diversify their portfolios.",
    ogUrl: process.env.ICM_URL,
    ogImgUrl: `${process.env.APP_IMAGES_PATH}icm-white-logo.webp?timestamp=${Date.now()}`,
};

export const ANNOUNCEMENT_METADATA = {
    title: ICM_NAME_FULL + " Revolutionizing Retail Wealth-Tech with Orowealth Acquisition",
    ogTitle: ICM_NAME_FULL + " Revolutionizing Retail Wealth-Tech with Orowealth Acquisition",
    description:
        "Experience " +
        ICM_NAME_FULL +
        " - Revolutionizing Retail Wealth-Tech with Orowealth. Diverse investments, personalized guidance, and robust technology platform. Join now!",
    ogDescription:
        "Experience " +
        ICM_NAME_FULL +
        " - Revolutionizing Retail Wealth-Tech with Orowealth. Diverse investments, personalized guidance, and robust technology platform. Join now!",
    ogUrl: `${process.env.ICM_URL}/announcement`,
    ogImgUrl: `${process.env.APP_IMAGES_PATH}icm-white-logo.webp?timestamp=${Date.now()}`,
};

export const INVESTOR_RELATIONS_METADATA = {
    title: "Investor Relations - " + ICM_NAME_FULL,
    keywords: "Alternate Investment Platform - Best Passive Income Investment",
    description:
        "Get detailed insights into " +
        ICM_NAME_FULL +
        "'s financial performance, corporate governance, and investor information. Access reports, presentations and key updates.",
    ogTitle: "Investor Relations - " + ICM_NAME_FULL,
    ogDescription:
        "Get detailed insights into " +
        ICM_NAME_FULL +
        "'s financial performance, corporate governance, and investor information. Access reports, presentations and key updates.",
    ogUrl: process.env.ICM_URL,
    itempropDescription:
        "Get detailed insights into  " +
        ICM_NAME_FULL +
        "'s financial performance, corporate governance, and investor information. Access reports, presentations and key updates.",
    ogImgUrl: `${process.env.APP_IMAGES_PATH}icm-white-logo.webp?timestamp=${Date.now()}`,
};

// PDF Links
export const CMLURL =
    "https://marketing.incredunlisted.com/Assets/Documents/Client-master-lists-ICU.pdf";
export const DEMAT_URL = "https://marketing.incredunlisted.com/Assets/Documents/ICU_DEMAT.pdf";
export const ICM_DEEPLINK_URL = "https://incredunlisted.app.link/3HGFpMW8nQb";
export const INVESTOR_REPORT_URL =
    "https://marketing.incredunlisted.com/Assets/webAssets/Annual Report-23-24-Alpha Fintech.pdf";
export const INVESTOR_NOTICE_URL =
    "https://marketing.incredunlisted.com/Assets/webAssets/IFS/Notice of Annual General Meeting-23-24.pdf";
export const INVESTOR_REPORT_URL2 =
    "https://marketing.incredunlisted.com/Assets/webAssets/Alpha+Annual+Report-+FY+24-25.pdf";
export const INVESTOR_NOTICE_URL2 =
    "https://marketing.incredunlisted.com/Assets/webAssets/Notice+of+Annual+General+Meeting+FY+24-25.pdf";
export const INVESTOR_ORDER_URL =
    "https://marketing.incredunlisted.com/Assets/webAssets/Alpha+booth+admission+order+-+CTC.pdf";
export const INVESTOR_MEETING_URL =
    "https://marketing.incredunlisted.com/Assets/webAssets/Form+CAA-2+-+Notice+of+the+NCLT+convened+meeting+of+ESH.pdf";
export const INVESTOR_MEETING_URL1 =
    "https://marketing.incredunlisted.com/Assets/webAssets/Alpha+-+Notice+to+unsecured+creditors.pdf";
export const INVESTOR_MEETING_URL2 =
    "https://marketing.incredunlisted.com/Assets/webAssets/Form+CAA+2+%E2%80%93+Newspaper+Publication+for+Meeting.pdf";
export const INVESTOR_MEETING_URL3 =
    "https://marketing.incredunlisted.com/Assets/webAssets/Scrutinizers+Report+-+Equity+Shareholders+-+Novemeber+3%2C+2025.pdf";
export const INVESTOR_TAB_URL =
    "https://marketing.incredunlisted.com/Assets/webAssets/Alpha+Fintech+Private+Limited+Consolidated+2022-23.pdf";
export const INVESTOR_TAB_URL1 =
    "https://marketing.incredunlisted.com/Assets/webAssets/Alpha+Fintech+Private+Limited+Consolidated+2023-24.pdf";
export const INVESTOR_TAB_URL2 =
    "https://marketing.incredunlisted.com/Assets/webAssets/Alpha+Fintech+Private+Limited+Consolidated+2024-25.pdf";
export const INVESTOR_TAB_URL3 =
    "https://marketing.incredunlisted.com/Assets/webAssets/Alpha+Fintech+Private+Limited+Standalone+2022-23.pdf";
export const INVESTOR_TAB_URL4 =
    "https://marketing.incredunlisted.com/Assets/webAssets/Alpha+Fintech+Private+Limited+Standalone+2023-24.pdf";
export const INVESTOR_TAB_URL5 =
    "https://marketing.incredunlisted.com/Assets/webAssets/Alpha+Fintech+Private+Limited+Standalone+2024-25.pdf";

export const SIGNUP_QUESTIONS = [
    /* {
        Title: "Tell us what you’re looking for",
        question: "What brings you here?",
        options: ["Unlisted shares"],
        qid: "3f18eefa-1c3e-4290-bfca-828d1041c6a6",
    }, */
    {
        Title: "Tell us what you’re looking for",
        question: "How much do you plan to invest?",
        options: [
            "Below 50K",
            "50K - 1L",
            "1L - 5L",
            "5L - 10L",
            "10L - 25L",
            "Above 25L",
            "I'm not sure",
        ],
        qid: "651160ceb590c72cedcdda41",
    },
    {
        Title: "Where did you hear about us?",
        question: "Select all that apply",
        options: [
            "Facebook / Instagram",
            "LinkedIn",
            "Youtube",
            "Akshat Shrivastav",
            "Friends / Family",
            "News / TV",
            "Other",
        ],
        qid: "651160b1b590c72cedcdda3f",
    },
];

export const graphColors: string[] = [
    "#4F6FFF",
    "#283A97",
    "#87BDDB",
    "#1594F5",
    "#4F6FFF",
    "#18619A",
];

export const subDomains = {
    NEUTRAL: String(process.env.ICM_URL?.split("https://")[1]?.trim()),
    STOCKS: String(process.env.ICM_STOCKS_URL?.split("https://")[1]?.trim()),
    PAYMENT: String(process.env.ICM_PAYMENT_URL?.split("https://")[1]?.trim()),
    BULLION: String(
        String(process.env.ICM_BULLION_POST_URL + DirectPaths.BULLION)
            ?.split("https://")[1]
            ?.trim(),
    ),
    // ALTS: String(process.env.ICM_UE_POST_URL?.split("https://")[1]?.trim()),
    // HOME: "home.icm.com:3000",
    // DEV: "dev.icm.com:3000",
};

export const apiBasedSubDomains = {
    GENERIC: String(process.env.API_BASE_URL?.trim()),
    NEUTRAL: String(process.env.API_BASE_URL?.trim()),
    STOCKS: String(process.env.API_STOCKS_URL?.trim()),
    PAYMENT: String(process.env.API_STOCKS_URL?.trim()), // same stocks API for payment.
    BULLION: String(process.env.API_BASE_URL?.trim()),
    // ALTS: String(process.env.API_STOCKS_URL?.trim()),
};

export const STOCK_METADATA: { [key: string]: { title: string; description: string } } = {
    "oravel-stays-ltd-(oyo-rooms)": {
        title: "Buy Oyo Rooms Unlisted Shares Online (ORAVEL STAYS LIMITED)",
        description:
            "Buy & Sell Oyo Rooms Unlisted Shares With  " +
            ICM_NAME_FULL +
            ". Explore detailed financials, market insights, and seamless transaction processes on  " +
            ICM_NAME_FULL +
            ".",
    },
    "national-stock-exchange-ltd-(nse)": {
        title: "Buy NSE India Unlisted Shares Online",
        description:
            "Trade NSE India unlisted shares effortlessly with  " +
            ICM_NAME_FULL +
            ". Access financial details, market insights, and smooth transactions.",
    },
    "national-e-repository-limited-nerl": {
        title: "NeRL Unlisted Shares | National e-Repository Ltd",
        description:
            "Explore National e Repository Limited (NeRL) unlisted shares, company overview, valuation, financials, share price, and investment insights.",
    },
    "kineco-ltd": {
        title: "Kineco Ltd Unlisted Shares Price - Buy & Sell Online",
        description:
            "Get the latest Kineco Ltd unlisted share price, company financials, business overview, valuation, and investment details with " +
            ICM_NAME_FULL +
            ".",
    },
    "gfcl-ev-products-limited": {
        title: "GFCL EV Products Limited Unlisted Shares",
        description:
            "Discover GFCL EV Products Limited unlisted shares, latest share price, company profile, financial performance, and investment information.",
    },
    "house-of-kieraya-ltd-furlenco": {
        title: "House of Kieraya (Furlenco) Unlisted Shares",
        description:
            "Explore House of Kieraya (Furlenco) unlisted shares, latest valuation, business overview, financials, and investment opportunities.",
    },
    "chennai-super-kings-cricket-ltd-(csk)": {
        title: "Buy CSK Unlisted Pre-IPO Shares",
        description:
            "Buy & Sell CSK Unlisted Shares on  " +
            ICM_NAME_FULL +
            ". Get real-time and insights on CSK Pre-IPO Share Prices & historical financial performance.",
    },
    "sbi-funds-management-ltd-(sbi-amc)": {
        title: "Buy SBI Funds Management Unlisted Shares",
        description:
            "Trade SBI Funds Management unlisted shares with  " +
            ICM_NAME_FULL +
            ". Access financial details, market insights, and smooth transactions with  " +
            ICM_NAME_FULL +
            ".",
    },
    "ncdex-ltd": {
        title: "NCDEX Unlisted Shares Price - Buy & Sell Online with  " + ICM_NAME_FULL,
        description:
            "Get the latest news and updates on NCDEX unlisted share price & track historical financial performance, market data and price charts with  " +
            ICM_NAME_FULL +
            ".",
    },
    "spray-engineering-devices-limited": {
        title: "Spray Engineering Devices Unlisted Shares Price - Buy & Sell Online",
        description:
            "Trade Spray Engineering Devices unlisted shares effortlessly with  " +
            ICM_NAME_FULL +
            ". Access financial details, market insights, and smooth transactions.",
    },
    "parag-parikh-financial-advisory-services-ltd-(ppfas)": {
        title: "Parag Parikh Financial Unlisted Shares - Buy/Sell",
        description:
            "Buy/Sell Parag Parikh Financial Unlisted Shares With InCred. Explore detailed financials, market insights, and seamless transaction processes on InCred.",
    },
    "orbis-financial-corporation-ltd": {
        title: "Orbis Financial Unlisted Shares Price - Buy/Sell",
        description:
            "Buy/Sell Orbis Financial Unlisted Shares With InCred. Explore detailed financials, market insights, and seamless transaction processes on InCred.",
    },
    "apollo-green-energy-ltd": {
        title: "Buy Apollo Green Energy Unlisted Shares",
        description:
            "Apollo Green Unlisted Shares Alternative Investment Made Easy. Explore market insights, financial data, and seamless transactions with  " +
            ICM_NAME_FULL +
            ".",
    },
    "indian-potash-ltd": {
        title: "Indian Potash Unlisted Shares - Buy & Sell Online",
        description:
            "Buy/Sell Indian Potash Unlisted Shares With InCred. Explore detailed financials, market insights, and seamless transaction processes on InCred.",
    },
    "hdb-financial-services-ltd": {
        title: "Buy & Sell HDB Financial Services Unlisted Shares Online",
        description:
            "Buy & Sell HDB Financial Services unlisted shares for potential growth. Explore market trends, financials, and opportunities before making informed decisions.",
    },
    "hella-infra-market-ltd": {
        title: "Buy Sell Hella Infra Market Unlisted Shares",
        description:
            "Buy Sell Hella Infra Market unlisted shares on  " +
            ICM_NAME_FULL +
            ". Check the latest Infra Market unlisted share price, valuation trends, and pre-IPO insights.",
    },
    "cochin-international-airport-ltd-(cial)": {
        title: "Buy & Sell Cochin International Airport Unlisted Shares at Best Price",
        description:
            "Buy & Sell Cochin International Airport Ltd unlisted shares. Analyze financials and potential growth opportunities before investing.",
    },
    "care-health-insurance-ltd-(religare)": {
        title: "Buy & Sell Care Health Insurance Ltd Unlisted Shares Price & Details",
        description:
            "Buy & Sell Care Health Insurance unlisted shares. A simple way to invest before the IPO with  " +
            ICM_NAME_FULL +
            " and grow your wealth.",
    },
    "imagine-marketing-ltd-(boat)": {
        title: "Buy & Sell Imagine Marketing Ltd (BoAt) - Unlisted Shres",
        description:
            "Buy & Sell Imagine Marketing Ltd (boAt) unlisted shares, get price trends, market potential, and key investment insights.",
    },
    "tata-capital-ltd": {
        title: "Buy & Sell Tata Capital Ltd Unlisted Shares",
        description:
            "Buy & Sell Tata Capital Ltd unlisted shares, get pricing, performance, and investment opportunities in the private market.",
    },
    "pharmeasy-(api-holdings-ltd)": {
        title: "Pharmeasy (API Holdings Ltd) Unlisted Shares",
        description:
            "Buy Pharmeasy unlisted shares at  " +
            ICM_NAME_FULL +
            ". Check latest Pharmeasy unlisted share price, valuation, financial updates & pre-IPO investment details",
    },
    "metropolitan-stock-exchange-of-india-ltd": {
        title: "Buy MSEI Unlisted Shares",
        description:
            "Check MSEI Unlisted Share Price, valuation trends & company details. Buy & Sell Metropolitan Stock Exchange (MESI) Unlisted Shares on  " +
            ICM_NAME_FULL +
            ".",
    },
    "sunday-proptech-ltd-(oyo-assets)": {
        title: "Sunday PropTech Pre-IPO Shares (OYO Assets)",
        description:
            "Invest in Sunday PropTech unlisted shares with  " +
            ICM_NAME_FULL +
            ". Track the latest unlisted share price and access in-depth financial analysis. Buy Now!",
    },
    "hero-fincorp-limited": {
        title: "Buy & Sell Hero Fincorp Ltd: Buy Unlisted Shares",
        description:
            "Buy & Sell Hero Fincorp unlisted shares on  " +
            ICM_NAME_FULL +
            ". Access pre-IPO opportunities and diversify your portfolio. Get started today!",
    },
    "signify-innovations-india-ltd-(previously-philips-lighting)": {
        title: "Signify Innovations India Ltd (Philips Lighting) Unlisted Shares",
        description:
            "Invest in Signify Innovations India Ltd (Philips Lighting) unlisted shares through  " +
            ICM_NAME_FULL +
            ". Unlock new financial possibilities and grow your portfolio!",
    },
    "elofic-industries-ltd": {
        title: "elofic-industries-ltd Unlisted Shares",
        description:
            "Find Elofic Industries Ltd unlisted share price, company overview, financials, valuation, and investment insights on " +
            ICM_NAME_FULL +
            ".",
    },
    "anheuser-busch-inbev-india-ltd": {
        title: "anheuser-busch-inbev-india-ltd Unlisted Shares",
        description:
            "Learn about Anheuser Busch InBev India Ltd unlisted shares, latest share price, company profile, financials, and investment details.",
    },
    "s3v-vascular-technologies-ltd": {
        title: "s3v-vascular-technologies-ltd Unlisted Shares",
        description:
            "Explore S3V Vascular Technologies Ltd unlisted shares, business overview, valuation, financials, and investment insights.",
    },
    "vivriti-capital-ltd": {
        title: "vivriti-capital-ltd Unlisted Shares",
        description:
            "Get Vivriti Capital Ltd unlisted share price, company financials, business overview, valuation, and investment opportunities.",
    },
    "parag-parikh-financial-advisory-services-ltd-ppfas-unlisted-shares": {
        title: "parag-parikh-financial-advisory-services-ltd-ppfas-unlisted-shares Unlisted Shares",
        description:
            "Discover PPFAS unlisted shares, latest share price, company overview, financials, valuation, and investment information.",
    },
    "philips-india-ltd": {
        title: "philips-india-ltd Unlisted Shares",
        description:
            "Explore Philips India Ltd unlisted shares, company profile, financial performance, valuation, latest share price, and investment insights.",
    },
    "pharmeasy-api-holdings-ltd": {
        title: "pharmeasy-api-holdings-ltd Unlisted Shares",
        description: "Learn about PharmEasy (API Holdings Ltd) unlisted shares, latest valuation, company financials, and investment opportunities."
    },
    "nayara-energy-ltd": {
        title: "nayara-energy-ltd Unlisted Shares",
        description:
            "Find Nayara Energy Ltd unlisted share price, company overview, financials, valuation, and investment insights with " +
            ICM_NAME_FULL +
            ".",
    },
    "maverick-simulation-solutions-ltd": {
        title: "maverick-simulation-solutions-ltd Unlisted Shares",
        description: "Explore Maverick Simulation Solutions Ltd unlisted shares, business profile, financials, valuation, and investment details."
    },
    "mohan-meakin-ltd": {
        title: "mohan-meakin-ltd Unlisted Shares",
        description: "Get Mohan Meakin Ltd unlisted share price, company overview, financial performance, valuation, and investment insights."
    },
    "alternicq-ltd-formerly-manjushree-technopack": {
        title: "alternicq-ltd-formerly-manjushree-technopack Unlisted Shares",
        description: "Explore Alternicq Ltd (formerly Manjushree Technopack) unlisted shares, valuation, financials, and investment opportunities."
    },
    "kannur-international-airport": {
        title: "kannur-international-airport Unlisted Shares",
        description: "Discover Kannur International Airport unlisted shares, company overview, financials, valuation, and investment information."
    },
    "indusind-general-insurance-company-ltd": {
        title: "indusind-general-insurance-company-ltd Unlisted Shares",
        description: "Learn about IndusInd General Insurance Company Ltd unlisted shares, company profile, valuation, and investment insights."
    },
    "indian-gas-exchange-ltd": {
        title: "indian-gas-exchange-ltd Unlisted Shares",
        description: "Explore Indian Gas Exchange Ltd unlisted shares, latest share price, company financials, valuation, and investment details."
    },
    "insolare-energy-limited": {
        title: "insolare-energy-limited Unlisted Shares",
        description: "Find InSolare Energy Limited unlisted share price, company overview, financials, valuation, and investment opportunities."
    },
    "greenzo-energy-india-ltd": {
        title: "greenzo-energy-india-ltd Unlisted Shares",
        description: "Explore Greenzo Energy India Ltd unlisted shares, company profile, financial performance, valuation, and investment insights."
    },
    "goodluck-defense-and-aerospace-ltd": {
        title: "goodluck-defense-and-aerospace-ltd Unlisted Shares",
        description: "Get Goodluck Defense and Aerospace Ltd unlisted share price, company overview, financials, valuation, and investment details."
    },
    "hdfc-securities-ltd": {
        title: "hdfc-securities-ltd Unlisted Shares",
        description: "Learn about HDFC Securities Ltd unlisted shares, latest valuation, company financials, business overview, and investment insights."
    },
    "indofil-industries-ltd": {
        title: "indofil-industries-ltd Unlisted Shares",
        description: "Explore Indofil Industries Ltd unlisted shares, latest share price, company profile, financials, valuation, and investment opportunities."
    },
    "chennai-super-kings-cricket-ltd-csk": {
        title: "chennai-super-kings-cricket-ltd-csk Unlisted Shares",
        description: "Discover Chennai Super Kings Cricket Ltd (CSK) unlisted shares, valuation, company overview, financials, and investment insights."
    },
    "cochin-international-airport-ltd-cial": {
        title: "cochin-international-airport-ltd-cial Unlisted Shares",
        description: "Explore Cochin International Airport Ltd (CIAL) unlisted shares, company overview, valuation, financials, and investment details."
    },
    "care-health-insurance-ltd-religare": {
        title: "care-health-insurance-ltd-religare Unlisted Shares",
        description: "Find Care Health Insurance Ltd (Religare) unlisted shares, company financials, valuation, latest share price, and investment insights."
    },
    "capgemini-technology-services-india-ltd": {
        title: "capgemini-technology-services-india-ltd Unlisted Shares",
        description: "Learn about Capgemini Technology Services India Ltd unlisted shares, company profile, valuation, financials, and investment opportunities."
    },
    "carrier-airconditioning-and-refrigeration-ltd": {
        title: "carrier-airconditioning-and-refrigeration-ltd Unlisted Shares",
        description: "Explore Carrier Airconditioning and Refrigeration Ltd unlisted shares, financials, valuation, and investment insights."
    },
    "bootes-impex-tech-limited": {
        title: "bootes-impex-tech-limited Unlisted Shares",
        description: "Discover Bootes Impex Tech Limited unlisted shares, latest share price, company overview, financials, valuation, and investment details."
    },
    "b9-beverages-ltd-bira91": {
        title: "b9-beverages-ltd-bira91 Unlisted Shares",
        description: "Explore B9 Beverages Ltd (BIRA91) unlisted shares, company overview, financial performance, valuation, and investment opportunities."
    },
    "ask-investment-managers-ltd": {
        title: "ask-investment-managers-ltd Unlisted Shares",
        description: "Learn about ASK Investment Managers Ltd unlisted shares, latest valuation, company financials, business overview, and investment insights."
    },
};

export const US_STOCK_METADATA: { [key: string]: { title: string; description: string } } = {
    /* "": {
        title: "",
        description: "",
    }, */
}; // common metadata set in layout file.

export const CSK_ISIN = "INE852S01026";

export const TEST_NEWS_DATA_PLATFORM = [
    {
        order: 1,
        webLink:
            "https://www.medianews4u.com/playr-continues-its-partnership-with-ipl-franchise-csk-for-2025-global-merchandising/",
        deepLink:
            "https://www.medianews4u.com/playr-continues-its-partnership-with-ipl-franchise-csk-for-2025-global-merchandising/",
        heading: "MN4U Bureau",
        description:
            "playR continues its partnership with IPL franchise CSK for 2025 Global Merchandising",
        thumbnail: "https://assets.incredunlisted.com/images/v2/webp/CSK.webp",
        publishDate: 1739471400000,
    },
    {
        order: 2,
        webLink:
            "https://www.news18.com/cricket/mi-csk-kkr-among-seven-ipl-franchises-submit-bids-to-buy-stake-in-the-hundred-report-9092980.html",
        deepLink:
            "https://www.news18.com/cricket/mi-csk-kkr-among-seven-ipl-franchises-submit-bids-to-buy-stake-in-the-hundred-report-9092980.html",
        heading: "news18.com",
        description:
            "MI, CSK, KKR Among Seven IPL Franchises Submit Bids to Buy Stake in The Hundred",
        thumbnail: "https://assets.incredunlisted.com/images/v2/webp/CSK.webp\t",
        publishDate: 1729794600000,
    },
    {
        order: 3,
        webLink:
            "https://timesofindia.indiatimes.com/sports/cricket/ipl/top-stories/ipl-retention-csk-chennai-super-kings-ms-dhoni-uncapped-player-rule/articleshow/114842043.cms",
        deepLink:
            "https://timesofindia.indiatimes.com/sports/cricket/ipl/top-stories/ipl-retention-csk-chennai-super-kings-ms-dhoni-uncapped-player-rule/articleshow/114842043.cms",
        heading: "The Times of India",
        description: "How did CSK retain MS Dhoni for Rs. 4cr ?",
        thumbnail: "https://assets.incredunlisted.com/images/v2/webp/CSK.webp",
        publishDate: 1730917800000,
    },
];

export enum ANNOUNCEMENT_TRIGGER_SCREENS {
    HomeScreen = "HomeScreen",
    ReferralScreen = "ReferralScreen",
    MldAssetsListing = "MldAssetsListing",
    BondsListing = "BondsListing",
    FDLandingScreen = "FDLandingScreen",
    UnlistedEquityScreen = "UnlistedEquityScreen",
    Profile = "Profile",
    UserKyc = "UserKyc",
    PortfolioScreen = "PortfolioScreen",
}
